/* eslint-disable import/prefer-default-export */

export const formatVehicleMakePlural = (make?: string) => {
  if (make === undefined) {
    return undefined;
  }
  const plural = make.endsWith('s');
  return plural ? `${make}'` : `${make}'s`;
};
